import { FC, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { theme, Layout, Drawer, Menu, message } from 'antd';
import type { MenuItemType } from 'antd/es/menu/hooks/useItems';

import { AuthContext, UIContext } from '../../../../contexts';

import { getItem } from './utils';
import { getMenuIcon } from './utils/icons';
import { MenuOption, SubMenu, UserInformation } from '../../../../interfaces';

import './index.css';

const { Sider } = Layout;

interface SideMenuProps {
  menus: Array<MenuOption>;
}

export const SideMenu: FC<SideMenuProps> = ({ menus = [] }) => {
  const authContext = useContext(AuthContext);
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const resp = authContext.getUserInfo() as UserInformation | null;

  let hasIntermediary = false;
  hasIntermediary = resp?.intermediarioSecundario != null;

  const navigate = useNavigate();
  const location = useLocation();

  const { isSideMenuOpen, isSiderCollapsed, toogleSideMenu, setMenuSelect, menuSelect } =
    useContext(UIContext);

  const [listMenu, setListMenu] = useState<Array<MenuItemType>>([]);

  const setMenu = (menu: Array<MenuOption>): void => {
    const menus = menu.map((item: MenuOption) => {
      let subMenus;

      if (item.subMenues.length > 0) {
        subMenus = item.subMenues.map((subMenu: SubMenu) =>
          getItem(subMenu.descripcion, subMenu.path, '')
        );
      }

      return getItem(
        item.descripcion,
        item.path,
        getMenuIcon(item.path),
        subMenus
      ) as MenuItemType;
    });

    setListMenu(menus);
  };

  const onNavigation = (url: string, event?: React.MouseEvent) => {
    if (hasIntermediary) {
      setMenuSelect([String(url)]);

      if (url) {
        // Check if the click is from an anchor link (has href starting with #)
        const isAnchorLink = event?.target && 
          (event.target as HTMLElement).closest('a[href^="#"]');
        
        const isSamePath = location.pathname === url || `${process.env.PUBLIC_URL || ''}${location.pathname}` === url;
        if (isSamePath && !isAnchorLink) {
          const separator = url.includes('?') ? '&' : '?';
          navigate(`${url}${separator}_=${Date.now()}`);
        } else {
          navigate(url);
        }
      }

      return;
    }

    setMenuSelect([]);
    const messageWarning = 'Debe seleccionar un intermediario.';
    message.warning(messageWarning);
  };

  useEffect(() => {
    if (menus.length) setMenu(menus);
    /* eslint-disable-next-line */
  }, [menus]);

  return (
    <>
    {hasIntermediary && (    
      <Sider
        width={280}
        style={{
          background: colorBgContainer,
          width: '100%',
          height: 'calc(100vh - 4rem)',
          overflowY: 'scroll',
          paddingTop: '1rem',
        }}
        collapsed={isSiderCollapsed}
        className='side-menu-xs-close'
      >
        <Menu
          theme='light'
          selectedKeys={hasIntermediary ? menuSelect : []}
          defaultOpenKeys={menuSelect}
          mode='inline'
          items={listMenu}
          onClick={({ key }) => onNavigation(key)}
        />
      </Sider>
      )}
      {hasIntermediary && (
      <Drawer
        open={isSideMenuOpen}
        placement='left'
        onClose={toogleSideMenu}
        className='side-menu-xs'
      >
        <Sider
          width={'100%'}
          style={{ background: colorBgContainer }}
          collapsed={false}
        >
          <Menu
            theme='light'
            selectedKeys={hasIntermediary ? menuSelect : []}
            defaultOpenKeys={menuSelect}
            mode='inline'
            items={listMenu}
            onClick={({ key }) => onNavigation(key)}
          />
        </Sider>
      </Drawer>
      )}
    </>
  );
};
